import { render, staticRenderFns } from "./VenueNewNearby.vue?vue&type=template&id=253dd8b4"
import script from "./VenueNewNearby.vue?vue&type=script&lang=ts"
export * from "./VenueNewNearby.vue?vue&type=script&lang=ts"
import style0 from "./VenueNewNearby.vue?vue&type=style&index=0&id=253dd8b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports